import { ColorLockedLegendItem } from "store/features/app/appSlice";

import { buildColorLockKey } from "./colorLockKey";

export enum ColorLockAction {
  Add = "add",
  Remove = "remove"
}

export interface ColorLockResult {
  isColorLocked: boolean;
  action: ColorLockAction;
  payload: ColorLockedLegendItem;
}

/**
 * Determines whether a legend item should be locked or unlocked based on
 * the incoming item color and the existing locked-colors map.
 *
 * - No existing entry → lock with the incoming color.
 * - Existing entry with a different color → update to the new color (stay locked).
 * - Existing entry with the same color → unlock.
 */
export function resolveColorLock(
  item: { property: string; value: string; color: string },
  lockedColors: Record<string, ColorLockedLegendItem>
): ColorLockResult {
  const key = buildColorLockKey(item.property, item.value);
  const existing = lockedColors[key];
  const isColorMatch =
    existing != null && existing.color?.toLowerCase() === item.color?.toLowerCase();

  if (existing && isColorMatch) {
    return {
      isColorLocked: false,
      action: ColorLockAction.Remove,
      payload: { color: item.color, value: item.value, property: item.property }
    };
  }

  return {
    isColorLocked: true,
    action: ColorLockAction.Add,
    payload: { color: item.color, value: item.value, property: item.property }
  };
}
